import type { Lang } from "@shared/types";
import { useI18n } from "./index";

/**
 * Feature-local dictionaries: a feature keeps its own strings in all three languages
 * (`{ ka, en, ru }`) next to its code, so features can grow without touching ka.ts.
 */
export function useLocalDict<T>(dict: Record<Lang, T>): T {
  const { lang } = useI18n();
  return dict[lang] ?? dict.ka;
}
